import '../scss/products.scss';

import productCarousel from './scripts/splide-products';
import splideProductSingle from './scripts/splide-product-single';

// import navigation from './scripts/navigation';

if(document.readyState !== 'loading') {
	runOnStart();
}
else {
	document.addEventListener('DOMContentLoaded', function () {
			runOnStart()
	});
}

function runOnStart() {
	// Run your code here
	// console.log('products.ts loaded')
	productCarousel();
	splideProductSingle();
}